import React, { useState } from 'react';

const TransactionDateFilter = ({ onFilterChange, totalTransactions, filteredTransactions }) => {
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');

  const filterOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last3months', label: 'Last 3 Months' },
    { value: 'last6months', label: 'Last 6 Months' },
    { value: 'last12months', label: 'Last 12 Months' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const handleFilterChange = (filterValue) => {
    setSelectedFilter(filterValue);
    
    if (filterValue === 'custom') {
      // Don't apply filter until custom dates are set
      return;
    }
    
    onFilterChange(filterValue, null);
  };

  const handleCustomDateChange = () => {
    if (customStartDate && customEndDate) {
      onFilterChange('custom', {
        startDate: customStartDate,
        endDate: customEndDate
      });
    }
  };

  const getFilteredCountText = () => {
    if (selectedFilter === 'all') {
      return `Showing all ${totalTransactions} transactions`;
    }
    return `Showing ${filteredTransactions} of ${totalTransactions} transactions`;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
            Filter by Date:
          </label>
          
          <select
            value={selectedFilter}
            onChange={(e) => handleFilterChange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
          >
            {filterOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {selectedFilter === 'custom' && (
            <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center">
              <input
                type="date"
                value={customStartDate}
                onChange={(e) => setCustomStartDate(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Start Date"
              />
              <span className="text-gray-500 hidden sm:inline">to</span>
              <input
                type="date"
                value={customEndDate}
                onChange={(e) => setCustomEndDate(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="End Date"
              />
              <button
                onClick={handleCustomDateChange}
                disabled={!customStartDate || !customEndDate}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
              >
                Apply
              </button>
            </div>
          )}
        </div>

        <div className="text-sm text-gray-600 font-medium">
          {getFilteredCountText()}
        </div>
      </div>

      {selectedFilter !== 'all' && (
        <div className="mt-4 p-3 bg-blue-50 rounded-md">
          <div className="flex items-center">
            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
            <span className="text-sm text-blue-700">
              Filtering transactions by <strong>billed date</strong> ({selectedFilter === 'custom' ? 'custom range' : filterOptions.find(opt => opt.value === selectedFilter)?.label})
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionDateFilter;
